import { useState, useCallback } from 'react';

export const useInstructions = () => {
  const [instructionState, setInstructionState] = useState({
    showInstructions: false,
    showConfirmation: false,
    showUnattempted: false,
    showTimeExpiry: false,
    currentSection: null,
    currentPart: null,
    mode: 'simulation',
    confirmationType: 'finish',
  });

  const showInstructionModal = useCallback((section, part = null, mode = 'simulation') => {
    setInstructionState(prev => ({
      ...prev,
      showInstructions: true,
      currentSection: section,
      currentPart: part,
      mode,
    }));
  }, []);

  const hideInstructionModal = useCallback(() => {
    setInstructionState(prev => ({
      ...prev,
      showInstructions: false,
    }));
  }, []);

  const showConfirmationDialog = useCallback((type = 'finish') => {
    setInstructionState(prev => ({
      ...prev,
      showConfirmation: true,
      confirmationType: type,
    }));
  }, []);

  const hideConfirmationDialog = useCallback(() => {
    setInstructionState(prev => ({
      ...prev,
      showConfirmation: false,
    }));
  }, []);

  const showUnattemptedDialog = useCallback(() => {
    setInstructionState(prev => ({
      ...prev,
      showUnattempted: true,
    }));
  }, []);

  const hideUnattemptedDialog = useCallback(() => {
    setInstructionState(prev => ({
      ...prev,
      showUnattempted: false,
    }));
  }, []);

  const showTimeExpiryDialog = useCallback(() => {
    setInstructionState(prev => ({
      ...prev,
      showTimeExpiry: true,
    }));
  }, []);

  const hideTimeExpiryDialog = useCallback(() => {
    setInstructionState(prev => ({
      ...prev,
      showTimeExpiry: false,
    }));
  }, []);

  const resetInstructionState = useCallback(() => {
    setInstructionState({
      showInstructions: false,
      showConfirmation: false,
      showUnattempted: false,
      showTimeExpiry: false,
      currentSection: null,
      currentPart: null,
      mode: 'simulation',
      confirmationType: 'finish',
    });
  }, []);

  return {
    instructionState,
    showInstructionModal,
    hideInstructionModal,
    showConfirmationDialog,
    hideConfirmationDialog,
    showUnattemptedDialog,
    hideUnattemptedDialog,
    showTimeExpiryDialog,
    hideTimeExpiryDialog,
    resetInstructionState,
  };
};

export default useInstructions;
